import { getToken } from "helper/common";
import {
    CLEAR_DOWNLOAD_APK,
    DOWNLOAD_APK_ERROR,
    DOWNLOAD_APK_ERROR_CLEAR,
    DOWNLOAD_APK_PENDING,
    SET_DOWNLOAD_APK_SUCCESS,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { saveAs } from 'file-saver';

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setDownloadAPKSuccess = () => ({
    type: SET_DOWNLOAD_APK_SUCCESS,
});

export const clearDownloadAPK = () => ({
    type: CLEAR_DOWNLOAD_APK,
});

export const downloadAPKPending = () => ({
    type: DOWNLOAD_APK_PENDING
});

export const downloadAPKError = (errorMessage) => ({
    type: DOWNLOAD_APK_ERROR,
    payload: { errorMessage }
});

export const downloadAPKErrorClear = () => ({
    type: DOWNLOAD_APK_ERROR_CLEAR
});

export const getDownloadAPK = (id) => (dispatch) => {
    dispatch(downloadAPKPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.downloadAPK.getDownloadAPK(accessToken, id)
            .then((downloadAPK) => {
                //console.log("downloadAPK: ", downloadAPK);
                saveAs(downloadAPK, "Kemin.apk");
                dispatch(setDownloadAPKSuccess());
                dispatch(downloadAPKErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Your APK is ready to download.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                let message;
                if (err?.response && err.response.body instanceof Blob) {
                    console.log(err.response.body);
                    err.response.body.text().then((errorText) => {
                        try {
                            message = errorText;
                        }
                        catch (parseError) {
                            message = "Something went wrong"
                        }
                        dispatch(downloadAPKError(message));
                    });
                }
                else if (err?.response && err.response.text instanceof Blob) {
                    console.log(err.response.body);
                    err.response.text.text().then((errorText) => {
                        try {
                            message = errorText;
                        }
                        catch (parseError) {
                            message = "Something went wrong"
                        }
                        dispatch(downloadAPKError(message));
                    });
                }
                else {
                    dispatch(downloadAPKError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
